import { useUserStrategies } from '../../../context/UserStrategies';
import PortfolioOverlapWidget from '../PortfolioOverlap/PortfolioOverlap';

import { PlaceholderStrategy } from '../../Strategies/Placeholder';
import { t } from 'i18next';
import { GridWidget } from '../types';

export const StrategiesOverlap = ({ width, height, loading }: GridWidget) => {
  const { strategies } = useUserStrategies();

  return strategies.length < 2 ? (
    <PlaceholderStrategy
      title={t('placeholders.compareStrategies.title')}
      subtitle={t('placeholders.compareStrategies.subtitle')}
    />
  ) : (
    <PortfolioOverlapWidget
      key={'PortfolioOverlap'}
      width={width > 3 ? 3 : width}
      height={height}
      standAlone={false}
      loading={loading}
    />
  );
};
